import SceneDownloadCard from "./scene-download-card.marko";

<ul class="ll-course-download-cards">
  <SceneDownloadCard href=input.pdf premium=input.premium firstModulePractice=input.firstModulePractice copy=input.copy/>
  <SceneDownloadCard href=input.solutions solutions premium=input.premium firstModulePractice=input.firstModulePractice copy=input.copy/>
</ul>
